<template>
  <div>
    <el-container>
      <el-header>
        <div class="el-header-word">
          <span>水产养殖监控平台</span>
        </div>
        <div class="el-header-exit">
          <div class="demo-basic--circle el-header-header">
            <div class="block">
              <el-avatar :size="40" :src="circleUrl"></el-avatar>
            </div>
            <div><span>&nbsp;&nbsp;{{username}}</span></div>
          </div>
          <div>
            关于&nbsp;|&nbsp;<span @click="exit" class="exit_point">退出</span>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <div class="menu_func">
            <div><i class="el-icon-menu"></i></div>
            <div><span>功能菜单</span></div>
          </div>
          <el-menu
            :default-active="active">
            <el-submenu index="1" class="subdirectory" v-if="username !== 'sgl'">
              <template slot="title" >
                <i class="el-icon-ship sub-temp-margin"></i>
                <span>环境监测</span>
              </template>
              <el-menu-item-group  v-for="(pond,i) in listPond" :key="pond.id" :index="1 + '-' + (i+1)">
                <router-link
                  :to="'/Query/'+pond.name+'/'+ pond.id"
                  tag="li"
                  class="el-menu-item">
                  {{pond.name}}
                </router-link>
              </el-menu-item-group>
            </el-submenu>
            <router-link index="8" to="/Analysis" tag="li" class="subdirectory el-menu-term el-menu-item" v-if="username !== 'sgl'">
              <i class="el-icon-s-data sub-temp-margin"></i>
              <span>曲线对比</span>
            </router-link>
            <router-link index="12" to="/downLoad" tag="li" class="subdirectory el-menu-term el-menu-item" v-if="username !== 'sgl'">
              <i class="el-icon-document sub-temp-margin"></i>
              <span>数据导出</span>
            </router-link>
            <router-link index="11" to="/termInfo" tag="li" class="subdirectory el-menu-term el-menu-item" v-if="username !== 'sgl'">
              <i class="el-icon-c-scale-to-original sub-temp-margin"></i>
              <span>设备状态</span>
            </router-link>
            <!--<router-link index="2" to="/TermMap" tag="li" class="subdirectory el-menu-term el-menu-item"  v-if="username !== 'sgl'">-->
              <!--<i class="el-icon-location-information sub-temp-margin"></i>-->
              <!--<span>生产单元分布图</span>-->
            <!--</router-link>-->
            <el-submenu index="3" class="subdirectory" v-if="username !== 'sgl'">
              <template slot="title">
                <i class="el-icon-files sub-temp-margin"></i>
                <span>配置管理</span>
              </template>
              <el-submenu index="3-1">
                <template slot="title">已有配置</template>
                <el-menu-item-group>
                  <router-link index="3-1-1" to="/Cell" tag="li" class="el-menu-item">生产单元</router-link>
                  <router-link index="3-1-2" to="/Term" tag="li" class="el-menu-item">终端</router-link>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu index="3-2">
                <template slot="title">新增配置</template>
                <el-menu-item-group>
                  <router-link index="3-2-1" to="/AddPond" tag="li" class="el-menu-item">增加生产单元</router-link>
                  <router-link index="3-2-2" to="/AddTerm" tag="li" class="el-menu-item">增加终端</router-link>
                  <router-link index="3-2-3" to="/AddSensor" tag="li" class="el-menu-item">增加传感器</router-link>
                  <router-link index="3-2-4" to="/AddEquip" tag="li" class="el-menu-item">增加设备</router-link>
                  <!--<router-link index="4-5" to="/chgPassword" tag="li" class="el-menu-item">修改密码</router-link>-->
                </el-menu-item-group>
              </el-submenu>
            </el-submenu>
            <el-submenu index="2" class="subdirectory" v-if="username !== 'sgl'">
              <template slot="title">
                <i class="el-icon-set-up sub-temp-margin"></i>
                <span>设备管理</span>
              </template>
              <el-menu-item-group >
                <router-link index="2-1" to="/manualControl" tag="li" class="el-menu-item">手工控制</router-link>
                <router-link index="2-2" to="/automatic" tag="li" class="el-menu-item">自动控制</router-link>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="14" class="subdirectory" v-if="username !== 'sgl'">
              <template slot="title">
                <i class="el-icon-notebook-1 sub-temp-margin"></i>
                <span>日志查看</span>
              </template>
              <el-menu-item-group >
                <router-link index="14-1" to="/controlLog" tag="li" class="el-menu-item">自动控制日志</router-link>
                <router-link index="14-2" to="/alarmLog" tag="li" class="el-menu-item">告警日志</router-link>
                <router-link index="14-3" to="/startAndStopLog" tag="li" class="el-menu-item">设备启停日志</router-link>
              </el-menu-item-group>
            </el-submenu>
            <!--<el-submenu index="7" class="subdirectory" v-if="username !== 'sgl'">-->
              <!--<template slot="title" >-->
                <!--<i class="el-icon-document-copy sub-temp-margin"></i>-->
                <!--<span>数据分析</span>-->
              <!--</template>-->
              <!--<el-menu-item-group v-for="(pond,i) in listPond" :key="pond.id" :index="7 + '-' + (i+1)">-->
                <!--<router-link-->
                  <!--:to="'/AllNum/'+pond.name+'/'+pond.id+'/'+'数据分析'"-->
                  <!--tag="li"-->
                  <!--class="el-menu-item">-->
                  <!--{{pond.name}}-->
                <!--</router-link>-->
              <!--</el-menu-item-group>-->
            <!--</el-submenu>-->
            <router-link index="5" to="/checkData" tag="li" class="subdirectory el-menu-term el-menu-item" v-if="username === 'sgl'">
              <i class="el-icon-data-line sub-temp-margin"></i>
              <span>环境监测</span>
            </router-link>
            <!--<router-link index="6" to="/analysisData" tag="li" class="subdirectory el-menu-term el-menu-item" v-if="username === 'sgl'">-->
              <!--<i class="el-icon-document-copy sub-temp-margin"></i>-->
              <!--<span>数据分析</span>-->
            <!--</router-link>-->
            <router-link index="9" to="/contrastData" tag="li" class="subdirectory el-menu-term el-menu-item" v-if="username === 'sgl'">
              <i class="el-icon-s-data sub-temp-margin"></i>
              <span>曲线对比</span>
            </router-link>
            <router-link index="10" to="/onlineDevice" tag="li" class="subdirectory el-menu-term el-menu-item" v-if="username === 'sgl'">
              <i class="el-icon-data-board sub-temp-margin"></i>
              <span>全网状态</span>
            </router-link>
          </el-menu>
        </el-aside>
        <el-main>
         <router-view :key="$route.fullPath" ></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      circleUrl: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3960397783,1027831749&fm=26&gp=0.jpg',
      isCollapse: true,
      listPond: {},
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      active: '3-1'
    }
  },
  methods: {
    exit () {
      window.sessionStorage.setItem('token', '')
      window.sessionStorage.setItem('username', '')
      this.$router.push('/')
    }
  },
  created () {
    if (this.username === 'sgl') {
      this.active = '5'
    }
    this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
      {
        params: {'username': this.username},
        headers: {'Authorization': 'Bearer ' + this.token}
      }).then(res => {
      // console.log(res.data.data)
      this.listPond = res.data.data.list
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<style scoped>
  .el-header{
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    background: -moz-linear-gradient(top, rgba(167,229,145,0.8) 0%, rgba(6, 176, 37, 0.8) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(167,229,145,0.8)), color-stop(100%,rgba(6, 176, 37, 0.8)));
    background: -webkit-linear-gradient(top, rgba(167,229,145,0.8) 0%,rgba(6, 176, 37, 0.8) 100%);
    background: -o-linear-gradient(top, rgba(167,229,145,0.8) 0%,rgba(6, 176, 37, 0.8) 100%);
    background: -ms-linear-gradient(top, rgba(167,229,145,0.8) 0%,rgba(6, 176, 37, 0.8) 100%);
    background: linear-gradient(to bottom, rgba(167,229,145,0.8) 0%,rgba(6, 176, 37, 0.8) 100%);
  }
  .el-aside {
    color: #606266;
    text-align: center;
    min-height: 549px;
    overflow-y: scroll
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    min-height: 706px;
    overflow-y: scroll;
  }
  .el-aside::-webkit-scrollbar{
    display:none;
  }
  .el-main::-webkit-scrollbar {
    display: none;
  }
  .el-header-word {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
  }
  .el-header-exit {
    font-size: 14px;
    color: #606266;
    display: flex;
    align-items: center;
  }
  .el-header-header {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  .menu_func {
    height: 50px;
    font-size: 16px;
    font-weight: bold;
    line-height: 50px;
    margin: 0 auto;
    background: -moz-linear-gradient(top, rgba(167,229,145,0.8) 0%, #a7e591 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(167,229,145,0.8)), color-stop(100%,#a7e591));
    background: -webkit-linear-gradient(top, rgba(167,229,145,0.8) 0%,#a7e591 100%);
    background: -o-linear-gradient(top, rgba(167,229,145,0.8) 0%,#a7e591 100%);
    background: -ms-linear-gradient(top, rgba(167,229,145,0.8) 0%,#a7e591 100%);
    background: linear-gradient(to bottom, rgba(167,229,145,0.8) 0%,#a7e591 100%);
    display: flex;
    justify-content: space-between;
    padding-left: 35px;
    padding-right: 71px;
  }
  .sub-temp-size {
    font-size: 1px;
  }
  .sub-temp-margin {
    margin-right: 5px;
  }
  .subdirectory {
    background: -moz-linear-gradient(top, rgba(167,229,145,0.3) 0%, rgba(167,229,145,0.6) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(167,229,145,0.3)), color-stop(100%,rgba(167,229,145,0.6)));
    background: -webkit-linear-gradient(top, rgba(167,229,145,0.3) 0%,rgba(167,229,145,0.6) 100%);
    background: -o-linear-gradient(top, rgba(167,229,145,0.3) 0%,rgba(167,229,145,0.6) 100%);
    background: -ms-linear-gradient(top, rgba(167,229,145,0.3) 0%,rgba(167,229,145,0.6) 100%);
    background: linear-gradient(to bottom, rgba(167,229,145,0.3) 0%,rgba(167,229,145,0.6) 100%);
  }
  .el-menu > .el-submenu{
  }
  .el-menu-term, .el-menu-open {
    height: 48px;
    line-height: 48px;
    padding-right: 60px;
    font-size: 14px;
    text-align: left;
    background: -moz-linear-gradient(top, rgba(167,229,145,0.4) 0%, rgba(167,229,145,0.6) 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(167,229,145,0.4)), color-stop(100%,rgba(167,229,145,0.6)));
    background: -webkit-linear-gradient(top, rgba(167,229,145,0.4) 0%,rgba(167,229,145,0.6) 100%);
    background: -o-linear-gradient(top, rgba(167,229,145,0.4) 0%,rgba(167,229,145,0.6) 100%);
    background: -ms-linear-gradient(top, rgba(167,229,145,0.4) 0%,rgba(167,229,145,0.6) 100%);
    background: linear-gradient(to bottom, rgba(167,229,145,0.4) 0%,rgba(167,229,145,0.6) 100%);
  }
  .el-menu-open {
    padding-right: 33px;
  }
  .exit_point {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/AquaCulture.vue